import React, {Fragment} from "react";

import { SmartErrorDiv } from "./SmartErrorDiv";

const   FormTextarea = ( { register, width, rows = 3, readOnly, label, sectionName, name, style, className, formErrors, maxLength, required } ) =>
{
    const classText = className === undefined ? "form-control" : '' ;

    return (
        <Fragment>
            { label !== undefined && <label id={'aria-label-' + name } htmlFor={'aria-label-' + name + '-input'} className='form-label'>{label}</label>}
            <textarea readOnly={readOnly}
                      rows={rows}
                   className={classText} {...register(sectionName + '.' + name, {
                required: required  ,
                maxLength: maxLength
            })} />
            <SmartErrorDiv sectionName={sectionName}  name={name} maxLength={maxLength} formErrors={formErrors} />
        </Fragment>
    )
}

export { FormTextarea }
